"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsSelect = exports.UsSelectStyleUlEnum = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const UsInput_1 = require("../UsInput/UsInput");
const UsHelpButton_1 = require("../UsHelpButton/UsHelpButton");
const UsSelect_style_1 = require("./UsSelect.style");
const UsInput_style_1 = require("../UsInput/UsInput.style");
const hooks_1 = require("../../hooks");
var UsSelectStyleUlEnum;
(function (UsSelectStyleUlEnum) {
    UsSelectStyleUlEnum["DEFAULT"] = "";
    UsSelectStyleUlEnum["NO_SPACE_TOP"] = "no-space-top";
})(UsSelectStyleUlEnum = exports.UsSelectStyleUlEnum || (exports.UsSelectStyleUlEnum = {}));
const UsSelect = (props) => {
    var _a, _b, _c;
    const [isMenuOpen, setMenuOpen] = react_1.default.useState(false);
    const selectedOption = (0, react_1.useMemo)(() => props.options.find((opt) => { var _a; return props.value && (props.value === opt.value) || (((_a = props.value) === null || _a === void 0 ? void 0 : _a.value) === opt.value); }), [props.value]);
    const selectedIndexOption = (0, react_1.useMemo)(() => props.options.findIndex((opt) => { var _a; return props.value && (props.value === opt.value) || (((_a = props.value) === null || _a === void 0 ? void 0 : _a.value) === opt.value); }), [props.value]);
    const closeMenu = () => setMenuOpen(false);
    const toggleMenu = () => setMenuOpen(!isMenuOpen);
    const onSelect = (opt) => {
        props.onChange && props.onChange(props.wholeOptionAsValue ? opt : opt.value);
        closeMenu();
    };
    const ref = (0, react_1.useRef)(null);
    const handleClickOutside = () => {
        if (isMenuOpen)
            closeMenu();
    };
    (0, hooks_1.useOnClickOutside)(ref, handleClickOutside);
    const handleClick = (e) => {
        if (!props.disabled)
            props.onClick && props.onClick();
        toggleMenu();
    };
    const handleBlur = (e) => {
        if (!props.disabled)
            props.onBlur && props.onBlur();
    };
    const handleFocus = (e) => {
        if (!props.disabled)
            props.onFocus && props.onFocus();
    };
    const handleInput = (e) => {
        if (!props.disabled)
            props.onInput && props.onInput();
    };
    const handleKeyUp = (e) => {
        if (!props.disabled)
            props.onKeyUp && props.onKeyUp();
    };
    const handleKeyDown = (e) => {
        if (!props.disabled)
            props.onKeyDown && props.onKeyDown();
    };
    return ((0, jsx_runtime_1.jsx)(UsSelect_style_1.UsSelectContainer, Object.assign({ className: `us-select ${props.className}` }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ ref: ref, className: `us-select-container`, "data-testid": "us-select-container" }, { children: (0, jsx_runtime_1.jsx)(UsInput_style_1.UsInputContainer, Object.assign({ className: "us-input" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "us-input-container" }, { children: [props.config.label && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "us-input-label" }, { children: (0, jsx_runtime_1.jsxs)("label", Object.assign({ htmlFor: props.config.name }, { children: [props.required && ((0, jsx_runtime_1.jsx)("span", { children: " * " })), props.config.label, props.config.tooltip && ((0, jsx_runtime_1.jsx)(UsHelpButton_1.UsHelpButton, { title: props.config.label, content: props.config.tooltip, type: (_a = props.config.tooltipType) !== null && _a !== void 0 ? _a : UsHelpButton_1.UsHelpButtonType.default }))] })) }))), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "us-input-wrapper", style: { backgroundColor: props.config.backgroundColor } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: `us-input-fake
                                    ${props.invalid ? 'us-input-wrapper-errors' : ''}
                                    ${props.disabled ? 'us-input-fake-disabled' : ''}
                                    ${props.required && !props.invalid ? 'us-input-wrapper-valid' : ''}
                                `.replace(/ +(?= )/g, ''), onClick: handleClick, onBlur: handleBlur, onFocus: handleFocus, onInput: handleInput, onKeyUp: handleKeyUp, onKeyDown: handleKeyDown, id: `combo${props.config.name}`, role: "combobox", "aria-haspopup": "listbox", "aria-controls": `listbox${props.config.name}`, "aria-expanded": isMenuOpen, "aria-labelledby": `combo${props.config.name}`, "aria-activedescendant": `${isMenuOpen ? 'combo' + selectedIndexOption + '-' + props.config.name : ''}`, tabIndex: 0, "data-testid": "us-select-toggle" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "us-input-fake-valore" }, { children: (_b = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) !== null && _b !== void 0 ? _b : props.config.placeholder })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "us-input-fake-icona" }, { children: (0, jsx_runtime_1.jsx)("i", { className: isMenuOpen ? 'icon-Freccia-up' : 'icon-Freccia-down' }) }))] })), (0, jsx_runtime_1.jsx)("ul", Object.assign({ className: `us-select-wrapper 
                                    ${props.usSelectStyleClassUl} 
                                    ${isMenuOpen ? 'opened' : ''} 
                                    ${props.config.label ? 'withLabel' : ''} 
                                    ${props.overlayPosition === 'top' ? 'top-overlay' : ''}
                                `, "data-testid": "us-select-menu", role: "listbox", id: `listbox ${props.config.name}`, "aria-labelledby": `combo-${props.config.name}` }, { children: props.options.map((option, i) => ((0, jsx_runtime_1.jsx)("li", Object.assign({ "data-testid": "us-select-option", className: `us-option-wrapper ${(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) === option.value ? 'active' : ''}`, role: "option", onClick: () => onSelect(option), id: `combo${i}-${props.config.name}`, "aria-selected": (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) === option.value }, { children: option.label })))) })), !props.hideErrorsInline && props.invalid && props.error && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: `us-input-errors-wrapper active` }, { children: (0, jsx_runtime_1.jsx)("span", { children: (_c = props.error) === null || _c === void 0 ? void 0 : _c.message }) })))] }))] })) })) })) })));
};
exports.UsSelect = UsSelect;
exports.UsSelect.defaultProps = {
    selectStyle: UsInput_1.UsSelectStyleEnum.DEFAULT,
    usSelectStyleClassUl: UsSelectStyleUlEnum.DEFAULT,
    usSelectValueStyle: UsInput_1.UsSelectValueStyleEnum.DEFAULT,
    className: '',
    options: [],
    wholeOptionAsValue: false,
    overlayPosition: 'bottom',
    hideErrorsInline: false,
    disabled: false,
    required: false,
    readOnly: false,
};
